export default __webpack_public_path__ + "static/media/score_card.9912b96a.svg";